import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";
import {modView_template} from "../components/templates/modView_template";

declare var ko: any;
declare var page: any;

export class mod_view extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected modView: modView_template;

    protected getModuleName(){

        return "mod_view";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.modView = new modView_template("viewForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("View Mod");

        return [this.modView.build()];
    }

    public fillPage() : void{

        this.getData();
    }

    protected getMemoryViewModel(){

        let templateViewModel = this.modView.getTemplateViewModel();
        return templateViewModel;
    }

    protected getData(){

        let id: number;

        if ((id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.modView.getTemplateViewModel().id(id);
        }

        this.loadingIn(this.modView.builtTemplate);

        let usrReq_url: string = '/api/mod/get/' + id;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.modView.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj){


        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.data);
                obj.loadingOut(obj.modView.builtTemplate);
            });
        }
    }

    protected updateList(data){

        this.modView.setId(data.id);
        this.modView.setTitle(data.title);
        this.modView.setShortDescription(data.shortDescription);
        this.modView.setModder( data.modderInfo ? (data.modderInfo.displayName || data.modderInfo.fullName || ''): '');
        this.modView.setModderId( data.modderInfo ? (data.modderInfo.id): '');
        this.modView.setStatus(data.status ? data.status.name : '');
        this.modView.setIdOrigin(data.idOrigin ? data.idOrigin : '');
        this.modView.setIsModProbation(data.modderInfo ? data.modderInfo.isModProbation : '');
        this.modView.setValnetUser(data.modderInfo ? data.modderInfo.idWebsiteUser : '');
        this.modView.setTag(data.tag ? data.tag.name : '');
        this.modView.setIsAdultOnly(data.isAdultOnly);
        this.modView.setGgpOptIn(data.ggpOptIn);
        this.modView.setModTypes(data.modTypes || []);
        this.modView.setDateModeration(data.dateModeration ? data.dateModeration.substring(0, 19) : '');
        this.modView.setFiles(data.modFiles || []);
        this.modView.setVersion(data.version || '');
        this.modView.setInstructions(data.instructions || '');
        this.modView.setDescription(data.description || '');
        this.modView.setCreated(data.created);
        this.modView.setUpdated(data.updated);
        this.modView.setRejectionReason(data.rejectionReason);
        this.modView.setModDependencies(data.modDependencies || []);

        if(data.moderationStatus){
            this.modView.setIdModerationStatus(data.moderationStatus.id);
            this.modView.setModerationStatus(data.moderationStatus.name);
        }

        if(data.moderator){
            this.modView.setIdModerator(data.moderator.id);
            this.modView.setModerator(data.moderator.fullName);  
        }
        
        for (let i = 0; i < data.modImages.length; i++) {
            if(data.modImages[i].isPrimary){
                this.modView.setPrimaryImage(data.modImages[i].image.url);
            }else{
                this.modView.setOtherImages(data.modImages[i].image);
            }
        }
    }

    protected edit(id) {

        page.redirect('/mods/edit/' + id);
    }


    protected cancel(id) {

        //release lock
        this.releaseLock(id);
        page.redirect('/mods/');
    }

    protected releaseLock(id) {

        // request a lock release
        let usrReq_url: string = '/api/mod/release/' + id;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

    protected seeContent(data, event) {
        console.log('MOD_VIEW', event);
        console.log('Data', data);
        let modal = document.getElementsByClassName('generic-modal');
        let content = document.getElementById('file-item-' + data);
        if(modal.length > 0) {
            modal[0].classList.contains('is-showing') ? modal[0].classList.remove('is-showing') : modal[0].classList.add('is-showing');
        }
        if(content != null && content != undefined) {
            content.classList.contains('is-showing') ? content.classList.remove('is-showing') : content.classList.add('is-showing');
        }else{
            let contentModal = document.getElementsByClassName('content-modal');
            for (let i = 0; i < contentModal.length; i++) {
                contentModal[i].classList.remove('is-showing');
            }

        }
    }

    public moderationAction(action, objType, id, rejectReason = '') {

        this.loadingIn(this.modView.builtTemplate);
        let moderationReq_url: string = '/api/mod/moderation/';
        let formReq_params: Array<Array<string>> = [];
        
                 //let subViewModel = JSON.parse( ko.toJSON(this.editForm.getViewModelForRequest()));
                formReq_params.push(["action", action]);
                formReq_params.push(["objType", objType]);
                formReq_params.push(["id", id]);
                formReq_params.push(["modId", this.getVnAppZone().app.params.id]);
                formReq_params.push(["rejectReason", rejectReason]);
        
                let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(moderationReq_url, formReq_params, this);
                XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
                XHRHdl.onReadyStateFunction = (function (req, obj) {
        
                    return function () {
        
                        obj.manageResponse(req, obj, function () {
        
                            if (req.request.status === 200) {
        
                                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Mod saved !");
        
                                page.redirect('/mods/view/' + obj.getVnAppZone().app.params.id);
                            }
                        });
                        
                        obj.loadingOut(obj.modView.builtTemplate);
                    }
                });
                XHRHdl.execute();
    }

    public downloadFile(fileUrl) {
        let moderationReq_url: string = '/api/mod/download/';
        let formReq_params: Array<Array<string>> = [];
        
                 //let subViewModel = JSON.parse( ko.toJSON(this.editForm.getViewModelForRequest()));
                formReq_params.push(["url", fileUrl]);
                
                let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(moderationReq_url, formReq_params, this);
                XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
                XHRHdl.onReadyStateFunction = (function (req, obj) {
        
                    return function () {
        
                        obj.manageResponse(req, obj, function () {
        
                            if (req.request.status === 200) {
                                let resp = JSON.parse(req.request.response);
                                if(resp.signedUrl != null && resp.signedUrl != undefined){
                                    console.log('REDIRECT', resp.signedUrl);
                                    window.open(resp.signedUrl, '_blank', 'noopener');
                                    //page.redirect(resp.signedUrl);
                                }
                                //obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Mod saved !");
        
                                //page.redirect('/mods/view/' + obj.getVnAppZone().app.params.id);
                            }
                        });
                    }
                });
                XHRHdl.execute();
    }

}


// WEBPACK FOOTER //
// ./js/modules/mod_view.ts